import React from 'react';
import PropTypes from 'prop-types';

import { UncontrolledTable } from '~/components';
import usePatient from '~/utils/patient/hook';
import { TableFilterDateRange, TableFilterIdentitySource } from '~/components/Filters';
import { MatchStatus } from '~/utils/const/identity';

const MissedAppointments = ({ allData }) => {
  const [, { sacwisPersonId: sacwisId }] = usePatient();

  return (
    <>
      <UncontrolledTable
        name="missed-appointments"
        className="mx-4"
        endpoint={{
          url: 'data/public/list-view-cs-tbl-appointments',
          params: {
            sacwis_id: sacwisId,
            apptcategory: 'Missed',
            match_status_id: MatchStatus.Approved,
            'all-data': allData ? '1' : null,
          },
        }}
        columns={[{
          id: 'appttimeTs__>>',
          Header: 'Date & Time',
          accessor: 'attributes.appttimeTs',
          cellType: 'date',
          Filter: d => <TableFilterDateRange {...d} />,
        }, {
          id: 'departmentname',
          Header: 'Clinic/Department',
          accessor: 'attributes.departmentname',
        }, {
          id: 'sourceDescription',
          Header: 'Reporting Healthcare Institution',
          accessor: 'attributes.sourceDescription',
          Filter: d => <TableFilterIdentitySource {...d} />,
        }, {
          id: 'encountertype',
          Header: 'Encounter Type',
          accessor: 'attributes.encountertype',
        }, {
          id: 'cancelreason',
          Header: 'Cancel Reason',
          accessor: 'attributes.cancelreason',
        }, {
          id: 'apptstatus',
          Header: 'Status',
          accessor: 'attributes.apptstatus',
        }]}
      />

      <p className="mt-3 text-center text-muted"><em>**Provides information on missed appointments for the previous 12 months, including no-shows and cancellations. Please note cancellations within 24 hours of appointment start time are marked as no-shows.</em></p>
    </>
  );
};

MissedAppointments.propTypes = {
  allData: PropTypes.bool,
};

MissedAppointments.defaultProps = {
  allData: false,
};

export default MissedAppointments;
